import { Grid, Typography, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Countdown, { zeroPad } from "react-countdown";

import { EVENT_START_DATE } from "src/library/constants";

export default function CountdownTimer() {
  const renderer = ({
    days,
    hours,
    minutes,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    completed: boolean;
  }) => <CountdownSectionContainer data={{ days, hours, minutes, completed }} />;

  return (
    <Container maxWidth="lg">
      <Countdown date={EVENT_START_DATE} renderer={renderer} />
    </Container>
  );
}

type CoundownContainerType = {
  days: number;
  hours: number;
  minutes: number;
  length?: number;
  completed: boolean;
};

const CountdownSectionContainer = ({ data }: { data: CoundownContainerType }) => {
  const { days, hours, minutes, length = 1, completed } = data;
  const theme = useTheme();
  const WHEN_MOBILE = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {!completed ? (
        <>
          <Grid
            container
            justifyContent={WHEN_MOBILE ? "space-between" : "center"}
            alignItems="center"
          >
            <CountdownSection data={zeroPad(days, length)} type="days" />
            <CountdownSection data={zeroPad(hours, length)} type="hours" />
            <CountdownSection data={zeroPad(minutes, length)} type="minutes" />
          </Grid>
          <Typography variant="h6" fontStyle="italic" sx={{ mt: 2 }}>
            Until we break down barriers in tech.
          </Typography>
        </>
      ) : null}
    </>
  );
};

const CountdownSection = ({ data, type }: { data: string; type: string }) => {
  const theme = useTheme();
  const WHEN_MOBILE = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      item
      container
      flexDirection="column"
      xs={WHEN_MOBILE ? 3.5 : 1.5}
      sx={{ mx: WHEN_MOBILE ? 0.5 : 1, backgroundColor: "#0A1929" }}
    >
      <Typography
        variant={WHEN_MOBILE ? "h2" : "h3"}
        fontWeight="bold"
        component="p"
        color="text"
        sx={{
          fontWeight: 800,
          p: WHEN_MOBILE ? 1.5 : 1,
        }}
      >
        {Number(data) === 1000 ? "-" : data}
      </Typography>
      <Typography
        variant="body1"
        color="text"
        fontWeight="bold"
        component="p"
        sx={{
          textTransform: "uppercase",
          backgroundColor: "common.black",
          py: 1,
          letterSpacing: WHEN_MOBILE ? 1 : 2,
        }}
      >
        {type}
      </Typography>
    </Grid>
  );
};
